const MOBILE_DEVICE = 'mobile';
const DESKTOP_DEVICE = 'desktop';
const TABLET_DEVICE = 'tablet';

module.exports = {
  MOBILE_DEVICE,
  DESKTOP_DEVICE,
  TABLET_DEVICE,
};



// WEBPACK FOOTER //
// ./app/request/device/constants.js